import React from 'react';

import IconButton from '@atlaskit/button/icon/button';
import EditIcon from '@atlaskit/icon/core/edit';

const IconButtonDefaultExample = (): React.JSX.Element => {
	return <IconButton icon={EditIcon} label="Edit" />;
};

export default IconButtonDefaultExample;
